import dynamic from 'next/dynamic';
import Ratio from 'react-ratio';

import { UserBookingDetailsQuery } from '@website/types/graphqlOperations';

const ReactPlayer = dynamic(() =>
  import('react-player').catch(() => null),
) as any;

export default function FAQVideos({
  videos,
}: {
  videos: UserBookingDetailsQuery['booking']['trip']['faqs']['items'][0]['videos'];
}) {
  return (
    <>
      {videos.map((video) => (
        <Ratio ratio={16 / 9} key={video.url} className="mb-3">
          <ReactPlayer
            url={video.url}
            width="100%"
            height="100%"
            controls
            playsinline
            light // Show just an image until clicked, to improve performance
            playing // So that it starts as soon as the light player button is clicked
          />
        </Ratio>
      ))}
    </>
  );
}
